import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common';
import { PlusKit as IconPlusKit } from 'education-icons';
import { Button, H2, SimpleText, Text, useGeneratePath, useStaticUrls } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { getSavedOrFirstTeamId } from 'common.components/user/selectors';
import { getInitialSubject } from 'store/subject-config/selectors';

const PortfolioEmpty = () => {
    const history = useHistory();
    const staticUrls = useStaticUrls();
    const getRouterPath = useGeneratePath();

    const subject = useSelector(getInitialSubject);
    const savedOrFirstTeamId = useSelector(getSavedOrFirstTeamId);

    const handleClick = () => {
        if (savedOrFirstTeamId) {
            history.push(
                getRouterPath(staticUrls.labClassLibrarySubjectTab, {
                    classId: savedOrFirstTeamId,
                    subject,
                    tabSlug: SUBJECT_LIBRARY_TAB_SLUG.MAIN,
                })
            );
        } else {
            history.push(
                getRouterPath(staticUrls.labLibrarySubjectTab, {
                    subject,
                    tabSlug: SUBJECT_LIBRARY_TAB_SLUG.MAIN,
                })
            );
        }
    };

    return (
        <div className="portfolio__empty">
            <H2
                id="teacherPortfolio.empty.title"
                mix="portfolio__empty-title"
                typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}
            />
            <Text
                className="portfolio__empty-description"
                id="teacherPortfolio.empty.description"
                typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
            />
            <Button icon={<IconPlusKit />} onClick={handleClick} view={Button.VIEW.ACTION}>
                <SimpleText id="teacherPortfolio.empty.buttonText" />
            </Button>
        </div>
    );
};

export default PortfolioEmpty;
